import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { DefinitionsService } from '../../../../../../app.common/modules/common/services/definitions.service';
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { IRetailerRootScope } from '../../../../core/models';
import { JispPayService } from '../../../jispPay.service';
import { ICompanyInformation } from '../../../models/ICompanyInformation';

class PaymentSettingsPopUp implements ng.IController {
    public static $inject = [
        'definitionsService',
        'notificationService',
        '$rootScope',
        'jispPayService',
        '$translate'
    ];
    public modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;
    public model: ICompanyInformation;
    public pattern: RegExp = this.definitionsService.regexNumbersAndLetters;
    public bankAccountError: boolean;
    public sortNumberError: boolean;

    public resolve: {
        currentCompanyInfo: ICompanyInformation;
    };

    constructor(
        public definitionsService: DefinitionsService,
        private notificationService: NotificationService,
        public $rootScope: IRetailerRootScope,
        private jispPayService: JispPayService,
        protected $translate: angular.translate.ITranslateService,
    ) {}

    public async $onInit() {
        if (this.resolve.currentCompanyInfo) {
            this.model = this.resolve.currentCompanyInfo;
        }
    }

    public close() {
        this.modalInstance.close();
    }

    public async saveForm() {
        this.sortNumberError = false;
        this.bankAccountError = false;
        if (!this.isFormInvalid()) {
            try {
                await this.jispPayService.putCompanyInfo(
                    this.model
                );
                this.modalInstance.close({ $value: 'ok' });
            } catch (error) {
                this.notificationService.showErrorMessage(error);
            }
        }
    }

    private isFormInvalid(): boolean {
        let hasErrors = false;
        if (this.model.SortCode && this.model.SortCode.length < 6) {
            this.sortNumberError = true;
            hasErrors = true;
        }
        if (this.model.BankAccount && this.model.BankAccount.length < 8) {
            this.bankAccountError = true;
            hasErrors = true;
        }

        return hasErrors;
    }
}

angular.module('naut').component('paymentSettingsPopUp', {
    template: require('./payment-settings-popup.component.html'),
    controller: PaymentSettingsPopUp,
    controllerAs: 'ctrl',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/jispPay/components/jisppayPlaces/payment-settings-popup/payment-settings-popup.component.ts